<template>
    <div class="sidebar rh" :class="{'sidebar-right-visible': showing}" @click="$emit('cart_close')">
        <div @click.stop="" class="sidebar-right">
            <h2>Ваш заказ</h2>
            <div class="cart-widget-actions">
                <button class="spin-button" @click="delCart">Очистить</button>
                <!--<button v-if="allowOrder" class="spin-button" @click="$emit('cart_close')"> Закрыть </button>-->
            </div>
            <ul class="cart-list">
                <li>
                    <span>Сумма: {{ (cartSum / 100).toFixed(2) }}</span>
                </li>
            </ul>
            <ul class="cart-list">
                <li v-for="item in cart" :key="item.code">
                    <pre>{{ item.name }}</pre>
                    <MenuItemSpin :MenuItem="item" :Summed="true"/>                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import MenuItemSpin from './MenuItemSpin'

export default {
    props:['cart', 'shop', 'showing'],
    data(){
        return{
            hovered: false,
            img:'./img/shopping-cart.svg'

        }
    },
    computed:{
        cartSum:function () {
            let amuont = 0
            for (let item of this.cart) {
                amuont += item.sum
            }
            return amuont
        },
        allowOrder(){
            if ((this.shop.minimalsum > 0) && (this.cartSum < this.shop.minimalsum*100)){
                return false
            } else return true
        }
    },
    mounted(){
        if (window.innerWidth < 500) {
            window.addEventListener('scroll', this.scrollHandler)
        }
    },
    destroyed(){
        window.removeEventListener('scroll', this.scrollHandler)
    },
    methods:{
        delItem: function(item){
            item.qty = 0
            item.sum = 0
        },
        delCart: function(){
            for (let item of this.cart){
                this.delItem(item)
            }
            this.$emit('cart_close')
        },
        showcart: function (){
            this.hovered = this.cartSum > 0
        },
        scrollHandler(){
            if (this.hovered) this.hovered = false
        }
    },
    watch:{
        cartSum: function (val) {
            this.hovered = this.hovered && (val > 0)
        }
    },
    components:{
        MenuItemSpin
    }
}
</script>